module.exports = __webpack_public_path__ + "static/media/savio11.65c713e9.jpg";